import React from "react";
import { Box, Typography } from "@mui/material";

const BoxCard = ({ title, details }: { title: string; details: string }) => {
    return (
      <Box
        sx={{
          width: '300px',
          height: '200px',
          background: '#68AFBC',
          display: 'flex',
          alignItems: 'center',
          padding: '20px',
          flexDirection: 'column',
          borderRadius: '4px',
          boxShadow: '0 4px 10px #0003',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
          {title}
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '18px', textAlign: 'center' }}>
          {details}
        </Typography>
      </Box>
    );
  };

  export default BoxCard;

  